/**
 * 非对称加密-RSA
 * 后端私钥加密 - 前端公钥解密
 */
/**
 * 非对称加密-RSA
 * 后端私钥加密 - 前端公钥解密
 */
import { JSEncrypt } from '../assets/jsencrypt/lib/JSEncrypt'
const PUBLICKY = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnDvbwXN5WNHOJ7NPq72fexMGKac6kpZ+5/quKzSIjQOVDYhjcwNTpjwMZhAW/KzWuc1GKwv0qZTb8xsnmMRnevXNX4KuLT/AhwXN6oFmXxTCTvTwf+a+Twpq5L/80f/vaU/O6FNky9RqsPtmS1v+AluCRXU+1yScBeVC2QiNbBiIDPORDvR31LOAN4KPloBClfVR2eZmupg7ULQvXE4A8APXcWAJUkg/7YdV1Ex8q+9sSrn/pbesr+ChfolQBp8L0/m/8k6AqGxp7cff8WAdE0SrEU78npkxnwkL5g09jia99lFywx/vcknJ8foVjcmrBvGfayefAjGdx5ME1dQR9QIDAQAB";

export const RSADECRY = {
  /**
   * rsa公钥加密
   * @param {*} key
   * @returns
   */
  setRsaByPublicKey(key) {
    const jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(rsaPublicKey)
    return jsencrypt.encrypt(key)
  },
  /**
   * rsa私钥解密
   * @param {*} key
   * @returns
   */
  decryptRsaByPrivateKey(key) {
    const decrypt = new JSEncrypt()
    decrypt.setPrivateKey(rsaPrivateKey)
    // 下文的""为了防止存于localStorage中的信息被不小心损坏
    return decrypt.decrypt(key) || ""
  },
  /**
   * 公钥解密
   * @param {String} val - 待解密的数据（Base64编码）
   * @param {String} publicKey - RSA公钥（可选，如果不提供则使用默认公钥）
   * @returns {String|false} 解密后的字符串，失败返回false
   */
  decryptByPublicKey: function (val = '', publicKey = null) {
    if (val === '') {
      return '';
    }
    let encrypt = new JSEncrypt();

    // 如果提供了公钥，使用提供的公钥；否则使用默认公钥
    const keyToUse = publicKey || PUBLICKY;

    // 如果公钥不是完整的PEM格式，需要转换
    let formattedKey = keyToUse;
    if (!keyToUse.includes('-----BEGIN PUBLIC KEY-----') && !keyToUse.includes('-----BEGIN RSA PUBLIC KEY-----')) {
      formattedKey = `-----BEGIN PUBLIC KEY-----\n${keyToUse}\n-----END PUBLIC KEY-----`;
    }

    encrypt.setPublicKey(formattedKey);

    //使用公钥对私钥加密后的数据解密
    return encrypt.decrypt(val);
  }
}